import env from '../../environment';
import {postCreator, getCreator, putCreator, deleteCreator} from '../../http';

export const endpoints = {
  LIST_PRODUCT_OPTION_GROUPS: `${env.baseApiUrl}/im/admin/product-option`,
  CREATE_PRODUCT_OPTION_GROUP: `${env.baseApiUrl}/im/admin/product-option`,
  UPDATE_PRODUCT_OPTION_GROUP: `${env.baseApiUrl}/im/admin/product-option/:storeProductOptionGroupId`,
  DELETE_PRODUCT_OPTION_GROUP: `${env.baseApiUrl}/im/admin/product-option/:storeProductOptionGroupId`,
  LIST_PRODUCT_OPTION_GROUP_OPTIONS: `${env.baseApiUrl}/im/admin/product-option/:storeProductOptionGroupId/option`,

  GET_PRODUCT_OPTION_GROUP_SETTINGS: `${env.baseApiUrl}/im/admin/product/:productId/options`,
};

export const listProductOptionGroupsApi = getCreator(
  endpoints.LIST_PRODUCT_OPTION_GROUPS
);
export const createProductOptionGroupApi = postCreator(
  endpoints.CREATE_PRODUCT_OPTION_GROUP
);
export const updateProductOptionGroupApi = putCreator(
  endpoints.UPDATE_PRODUCT_OPTION_GROUP
);
export const deleteProductOptionGroupApi = deleteCreator(
  endpoints.DELETE_PRODUCT_OPTION_GROUP
);
export const listProductOptionGroupOptionsApi = getCreator(
  endpoints.LIST_PRODUCT_OPTION_GROUP_OPTIONS
);
export const getProductOptionGroupSettingsApi = getCreator(
  endpoints.GET_PRODUCT_OPTION_GROUP_SETTINGS
);
